import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaSearch, FaTwitter } from "react-icons/fa";

import { useGetUserMeta } from "@/api/queries";
import useDomainConfigAuth from "@/api/sanity/queries/getSiteConfigWithDomain";
import AuthPrimaryButton from "@/components/AuthPrimaryButton";
import H1 from "@/components/H1";
import Input from "@/components/Input";
import P from "@/components/P";
import Select from "@/components/Select";
import Spacer from "@/components/Spacer";
import useGetColours from "@/helpers/getColours";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";

function AddTwitter() {
  const { t } = useTranslation("onboarding");
  const navigate = useNavigate();
  // const apiUrl = AppState.getRawState()?.apiUrl;
  const apiUrl = useAppStore(state => state.apiUrl);
  // const twitterResult = AppState.useState((s) => s.addAccount.twitter);
  const [pending, setPending] = useState(false);
  const { data: domainConfig } = useDomainConfigAuth();
  const isTunecore = domainConfig?.display_name === "TuneCore";
  const { onboardingHighlightColour } = useGetColours(domainConfig);

  const userMeta = useGetUserMeta();

  let title = t("onboarding:add-twitter-header1");
  let desc = t("onboarding:add-twitter-desc1");

  switch (userMeta?.data?.role) {
    case "Manager":
      title = t("onboarding:add-twitter-header2");
      desc = t("onboarding:add-twitter-desc2");

      break;
    default:
      break;
  }

  const getSelectOptions = query =>
    new Promise((resolve, reject) => {
      if (!query) {
        resolve([]);
        return;
      }
      fetch(`${apiUrl}/twitter?s=${query.replace("@", "")}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(response => response.json())
        .then((user) => {
          if (user.errors) {
            reject(user.errors);
          }
          resolve([
            {
              value: JSON.stringify(user),
              name: user.data.name,
              photo: user.data.profile_image_url,
            },
          ]);
        })
        .catch(reject);
    });

  // const addAccount = AppState.useState(s => s.addAccount);
  const addAccount = useAppStore(state => state.addAccount || {});
  const show = false;

  return (
    <div className="container mx-auto">
      <div className="flex flex-col items-center justify-center p-4 text-center text-white min-h-screen-minus-footer">
        <p className="text-6xl text-white">
          <FaTwitter />
        </p>

        <Spacer />
        <>
          <H1>{title}</H1>
          <Spacer />
          <P>{desc}</P>
          <Spacer />
          {show && (
            <div className="relative flex flex-col items-center justify-center w-full">
              <div className="w-full lg:w-1/3">
                <div className="flex flex-row items-start justify-center w-full text-ink-primary">
                  <Select
                    className={` custom-select no-dropdown ${
                      isTunecore ? "tunecore-select tunecore-input-hover" : ""
                    } `}
                    debounce={1000}
                    onChange={(artist) => {
                      // AppState.update((s) => {
                      //   s.addAccount.twitter = artist;
                      // });
                      useAppStore.getState().setAddAccountSocial("twitter", artist);
                    }}
                    getOptions={getSelectOptions}
                    placeholder="@"
                    search
                    authSearch
                  />
                  <div
                    className="p-4 ml-4 -mt-1 text-xl text-black rounded-full"
                    style={{ backgroundColor: onboardingHighlightColour }}
                  >
                    <FaSearch />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="relative flex flex-col items-center justify-center w-full text-ink-primary">
            <div
              className={`w-full lg:w-1/3  ${
                isTunecore ? "tunecore-input-hover" : ""
              }`}
            >
              <Input
                className={` auth-page-input${
                  isTunecore ? "auth-tunecore-page-input" : ""
                }`}
                placeholder="@username"
                whiteLabelText
                value={addAccount.twitter}
                onChange={e =>
                  useAppStore.setState(state => ({
                    addAccount: {
                      ...state.addAccount,
                      twitter: e.target.value,
                    },
                  }))}
              />
            </div>
          </div>
        </>

        {/* {!!twitterResult
            && (
              <>
                <H1>{t('onboarding:selected-twitter-profile')}</H1>
                <Spacer />
                <div className="flex flex-col items-center p-4 px-6 bg-white rounded-lg shadow-lg text-ink-primary">
                  {JSON.parse(twitterResult).data.profile_image_url && JSON.parse(twitterResult).data.profile_image_url.length > 0
                    && (
                    <img
                      className="object-cover w-20 h-20 mb-4 rounded-full"
                      alt={JSON.parse(twitterResult).data.name}
                      src={JSON.parse(twitterResult).data.profile_image_url}
                    />
                    )}
                  {(!JSON.parse(twitterResult).data.profile_image_url)
                    && <div className="w-20 h-20 mb-4 bg-gray-300 rounded-full" />}
                  <p className="mb-4 font-bold">{JSON.parse(twitterResult).data.name}</p>
                  <SmallButton onClick={() => { AppState.update((s) => { s.addAccount.twitter = null; }); }}>{t('common:remove')}</SmallButton>
                </div>

              </>
            )} */}

        <Spacer />

        <div className="flex flex-row justify-center w-full lg:w-1/3">
          <AuthPrimaryButton
            pending={pending}
            onClick={() => {
              void navigate({ to: "/add-account-6" });
              setPending(true);
            }}
            arrow
          >
            {t("common:_done")}
          </AuthPrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default AddTwitter;
